export interface Tariff {
  id_tariff: number;
  tariff_name: string | null;
  description: string | null;
  country: string;
  account_type_name: string;
  full_ab_plata: number | null;
  is_start: number | null;
  test_days: number;
  id_tariff_vc: number | null;
  count_cameras: number | null;
  start_tariff_lv_monitor: number | null;
  // в списке может не приходить или приходить null — тогда колонка «В приложении» не показывается
  is_showed?: number | null;
}

export interface TariffDetail {
  tariff_name: string;
  ab_plata: number;
  description: string;
  id_country: number;
  id_account_type: number;
  id_archive_period: number;
  test_days: number;
  is_showed: number;
  for_oper: number | null;
  is_start: number | null;
  id_tariff_vc: number | null;
  users_choice: number | null;
  periods_count: number | null;
  show_if_count_abon_cameras_is: number | null;
  has_discount: number | null;
  bonus_days: number | null;
  id_tariff_after_bonus: number | null;
  for_move: number | null;
  tariff_length: number | null;
  is_tariff_lv_monitor: number | null;
  start_tariff_lv_monitor: number | null;
  no_show_tariff_with_location: number | null;
  account_description: string;
  desc_recomm_pay: string;
}

export interface TariffFormData {
  tariff_name: string;
  ab_plata: string;
  description: string;
  id_country: string;
  id_account_type: string;
  id_archive_period: string;
  test_days: string;
  tariff_length: string;
  is_showed: boolean;
  for_oper: boolean;
  // значение справочника биллинга: 0 — нет, 1 — только в первый раз, 2 — основной, 3 — после триала
  is_start: string;
  id_tariff_vc: string;
  users_choice: boolean;
  periods_count: string;
  show_if_count_abon_cameras_is: string;
  has_discount: boolean;
  bonus_days: string;
  id_tariff_after_bonus: string;
  for_move: boolean;
  is_tariff_lv_monitor: boolean;
  start_tariff_lv_monitor: string;
  no_show_tariff_with_location: boolean;
  account_description: string;
  desc_recomm_pay: string;
}

export const emptyFormData: TariffFormData = {
  tariff_name: '',
  ab_plata: '',
  description: '',
  id_country: '',
  id_account_type: '',
  id_archive_period: '',
  test_days: '',
  tariff_length: '',
  is_showed: true,
  for_oper: true,
  is_start: '0',
  id_tariff_vc: '',
  users_choice: false,
  periods_count: '',
  show_if_count_abon_cameras_is: '',
  has_discount: false,
  bonus_days: '',
  id_tariff_after_bonus: '',
  for_move: false,
  is_tariff_lv_monitor: false,
  start_tariff_lv_monitor: '',
  no_show_tariff_with_location: false,
  account_description: '',
  desc_recomm_pay: '',
};
